import { IMAGE_PROCESSOR_URL } from "../api";

interface ImageOptions {
    width?: number;
    height?: number;
    quality?: number;
}

/**
 * Cloudflare Worker 経由で画像 URL を組み立てる。
 * bucket 引数は旧 API との互換のため受け取るが、Worker 側では
 * 単一の R2 バケット (yuko-illustrations) を path で直接引くため無視される。
 */
export const getStorageImageUrl = async (
    bucket: string,
    storagePath: string,
    options: ImageOptions = { width: 320, height: 320, quality: 80 },
): Promise<string> => {
    const url = new URL(IMAGE_PROCESSOR_URL);
    // Worker 側では単一の R2 バケットを path 直引きするため bucket は実質無視だが、
    // 旧 API と互換を保つためパラメータ自体は付けておく。
    url.searchParams.set("bucket", bucket);
    url.searchParams.set("path", storagePath);
    if (options.width) url.searchParams.set("width", options.width.toString());
    if (options.height) url.searchParams.set("height", options.height.toString());
    if (options.quality) url.searchParams.set("quality", options.quality.toString());
    return url.toString();
};

export const getPublicUrl = async (bucket: string, storagePath: string) => {
    return getStorageImageUrl(bucket, storagePath, {});
};

export const STORAGE_BUCKETS = {
    ILLUSTRATIONS: "illustrations",
    THUMBNAILS: "thumbnails",
    FEATURES: "features",
} as const;

export type StorageBucket =
    typeof STORAGE_BUCKETS[keyof typeof STORAGE_BUCKETS];
